export default{
	name : 'household_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		hjyw() {
			window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.hjyw%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
		},
		sfz1() {
			window.location.href = "https://user.cs96111.com/ad/record/url/auth?data=8;65;1";
		},
		sfz2() {
			this.$router.push('/id2')
		},
		sfzcx() {
			window.location.href = "https://user.cs96111.com/ad/record/url/auth?data=8;66;1";
		},
		sfzjf() {
			window.location.href = "https://user.cs96111.com/ad/record/url/auth?data=8;67;1";
		},
		more() {
			this.$router.push('/micro_police')
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/household_dialog/household_dialog.controller.js